<template>
  <ankh-list :showSearchForm="false">
    <template #btn-group>
      <el-button @click.native="handleShowFormDialog()">{{$t('新增')}}</el-button>
      <!--  todo 导出  -->
      <el-button>{{$t('导出')}}</el-button>
      <el-button @click.native="handleBatchDelete">{{$t('批量删除')}}</el-button>
    </template>

    <template #table="{height}">
      <table-list
          ref="list"
          :height="height"
          @query="handleSearch"
          :search-params="searchForm"
          :data="tableData"
          @selection-change="selection = $event">

        <el-table-column type="selection" width="50"/>
        <el-table-column type="index" :label="$t('序号')" width="50" fixed />

        <el-table-column prop="name" :label="$t('名称')" fixed />
        <el-table-column prop="address" :label="$t('声音设置')">
          <template  v-slot="{row}">
            <div class="flex">
              <img src="@/assets/sound.png" class="sound" v-if="row.soundSet" />
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('协议代码')">
          <template v-slot="{row}">
            <div class="flex" style="column-gap: 6px" v-if="row.protocolCode">
              <el-link :underline="false" type="primary">{{ row.protocolCode || "" }}</el-link>
              <i class="el-icon-copy-document" @click="handleCopy(row)" />
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('备注')" prop="remark" />
        <el-table-column :label="$t('操作')" min-width="30">
          <template v-slot="{row}">
            <div class="fb-link-flex">
              <el-link type="primary" :underline="false" @click="handleShowFormDialog(row)">{{$t('编辑')}}</el-link>
              <el-link type="danger" :underline="false" @click="handleDelete(row)">{{$t('删除')}}</el-link>
            </div>
          </template>
        </el-table-column>
      </table-list>
    </template>

    <template #other>
      <part-sound-form
          @confirm="handleAddOrEditSubmit"
          :visible.sync="showDialog"
          :is-edit="isEdit"
          :data="currentRow" />
    </template>
  </ankh-list>
</template>

<script>
import {request, requestByTip} from "@/config/request";
import TableList from "@/components/table-list/TableList";
import PartSoundForm from "@/components/part-sound/PartSoundForm";
import {exeCommandCopyText} from "@/utils/common";
import AnkhList from "@/components/list/AnkhList.vue";

export default {
  name: "PatSoundList",
  components: {AnkhList, PartSoundForm, TableList},
  data() {
    return {
      showDialog: false,
      searchForm: {},
      tableData: [],
      selection: [],
      isEdit: false,
      currentRow: {}
    }
  },
  methods: {
    // 复制
    handleCopy(row) {
      const flag = exeCommandCopyText(row.protocolCode)
      this.$message({
        type: flag ? 'success' : 'error',
        message: flag ? this.$t('复制成功') : this.$t('复制失败')
      })
    },

    // 新增\编辑
    async handleAddOrEditSubmit(data) {
      try {
        const action = this.$api.rangeSoundSet[this.isEdit ? 'update' : 'add'];
        if(this.isEdit) {
          data = Object.assign(this.currentRow, data);
          delete data.createTime;
          delete data.updateTime;
        }
        await request(action, data);
        this.$message.success(this.$t('操作成功'));
        this.showDialog = false;
        this.$refs.list.handleRequest();
      } catch (e) {
        console.log(e);
      }
    },

    handleShowFormDialog(row) {
      if(row) {
        this.currentRow = {...row};
        this.isEdit = true;
      } else {
        this.isEdit = false;
      }
      this.showDialog = true;
    },

    async handleDelete(row) {
      try {
        await requestByTip(this.$api.rangeSoundSet.delete, {code: row.code});
        this.$message.success(this.$t('操作成功'))
        this.$refs.list.handleRequest(1);
      } catch (e) {
        console.error(e);
      }
    },

    async handleBatchDelete() {
      if (!this.selection.length) {
        this.$message({
          type: 'warning',
          message: this.$t('未选择记录')
        });
        return;
      }
      try {
        let codes = this.selection.map(item => item.code);
        await requestByTip(
            this.$api.rangeSoundSet.batchDelete,
            codes,
            {isJson: true},
            {message: this.$t('您现在正在进行批量删除操作, 是否继续?')}
        );
        this.$message.success(this.$t('操作成功'));
        this.$refs.list.handleRequest(codes.length);

      } catch (e) {
        console.error(e);
      }
    },

    async handleSearch(params, setTotal) {
      try {
        let res = await request(this.$api.rangeSoundSet.list, params);
        for (let key in res) {
          if (res[key] instanceof Array) {
            this.tableData = res[key];
          }
        }
        setTotal(res.pager?.itemCount);
      } catch (e) {
        console.error(e);
      }
    }
  },
}
</script>

<style scoped>

.sound {
  width: 30px;
  height: 30px;
  margin-right: 10px;
}

</style>
